import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { Navbar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../Assets/logo-chriis.png";

function BarraNavegacion({ title }) {
  return (
    <>
      <Navbar bg="dark" data-bs-theme="dark" className="d-flex hero">
        <div className="d-ruby m-auto">
          <Row >
            <Nav className="me-auto justify-content-center flex-grow-1 pe-3">
              <h1 className="text-light"> {title} </h1>
            </Nav>
          </Row>
          <Row>
            <Navbar.Brand href="/">
              <img
                src={Logo}
                width="80"
                height="100"
                // className="d-inline-block align-top"
                alt="React Bootstrap logo"
              />
            </Navbar.Brand>
          </Row>
        </div>
      </Navbar>
      <Navbar bg="dark" data-bs-theme="dark" className="mb-3">
        <Container>
          <Nav className="me-auto justify-content-center flex-grow-1 pe-3">
            <Link to="/" className="link-text">
              Inicio |
            </Link>
            <Link to="/mis-codigos" className="link-text">
              Mis compras
            </Link>
            <Link to="/contactanos" className="link-text">
              {" "}
              | Contactanos
            </Link>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
}

export default BarraNavegacion;
